import React from 'react';

import cx from 'classnames';

import FocalImage from 'components/Layouts/Form/FormBuilder/FocalImage';
import { getAssetSrcFromId, ASSET_SIZE_TYPES } from 'utils/asset';

import Upload from '../AddNewContent/Upload';
import { IUploadProps } from '../AddNewContent/Upload/types';
import styles from './index.module.css';
import Slider from './Slider';
import { getImageCoords } from './utils';

const GRID_COUNT = 2;
const DROPZONE_COUNT = 0;

function Image(props: IUploadProps) {
  const { data, showLegend = false } = props;
  const filesLength = data.data?.files?.length || 0;
  const imgBlockClasses = cx(styles.imgBlock, filesLength === GRID_COUNT && styles.imgBlockGrid, 'custom-image');

  if (filesLength === DROPZONE_COUNT) {
    return <Upload {...props} availableInBasic={data.availableInBasic} />;
  }

  if (filesLength > GRID_COUNT) {
    return <Slider files={data.data?.files || []} showLegend={showLegend} />;
  }

  return (
    <div className={styles.wrapper}>
      {data.data?.files.map((file) => (
        <div key={file?.url} className={imgBlockClasses}>
          {/*@ts-ignore*/}
          <FocalImage
            point={getImageCoords(file?.imageCoords)}
            src={getAssetSrcFromId(file?.id)}
            key={data.data.files.length}
            fileAccId={file?.accountId}
            // defaultSrc={previewUrl}
            pictureSources={[
              {
                media: '(max-width: 1500px)',
                srcSet: `${getAssetSrcFromId(file?.id, ASSET_SIZE_TYPES.VERSION_400)}, ${getAssetSrcFromId(
                  file?.id,
                  ASSET_SIZE_TYPES.VERSION_800,
                )} 2x`,
              },
              {
                media: '(min-width: 1501px)',
                srcSet: `${getAssetSrcFromId(file?.id, ASSET_SIZE_TYPES.VERSION_800)}, ${getAssetSrcFromId(
                  file?.id,
                  ASSET_SIZE_TYPES.VERSION_1600,
                )} 2x`,
              },
            ]}
          />
        </div>
      ))}
    </div>
  );
}

export default Image;
